import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as group from '../group'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: group.RESOURCE.payload.dimension.partialId,
      partialId: group.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Identifies which IDC rate is applicable to this project',
    isOptional: true,
    name: 'IDC Rate Group',
    partialId: PartialId.Standard.create('idc_rate_group'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.idcRateGroup.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
